import {IOrganization, OrganizationMfaLevel} from "@chaosinsight/postoffice-portalclient"

export default class OrganizationSecurity {
	public readonly mfaRequired: OrganizationMfaLevel
	public readonly loginDurationMinutes: number | null

	constructor(mfaRequired: OrganizationMfaLevel, loginDurationMinutes: number | null) {
		this.mfaRequired = mfaRequired
		this.loginDurationMinutes = loginDurationMinutes
	}

	public clone(mfaRequired?: OrganizationMfaLevel, loginDurationMinutes?: number | null): OrganizationSecurity {
		return new OrganizationSecurity(mfaRequired ?? this.mfaRequired, loginDurationMinutes !== undefined ? loginDurationMinutes : this.loginDurationMinutes)
	}

	public static fromApi(data: Pick<IOrganization, "MfaLevel" | "RefreshTokenExpirationInMinutes">): OrganizationSecurity {
		return new OrganizationSecurity(data.MfaLevel, data.RefreshTokenExpirationInMinutes)
	}
}

export {OrganizationMfaLevel}
